import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NavBar = props => {
         return (
            <div>

    <div className="container-fluid big-logo-row">
    <div className="nav-wrapper" style={{height: "80px"}}> 
      <div className="navbar">
          
          <ul className="nav">
            
            <li>
                <a href="#techHeader">Technical Expertise</a>
            </li>
            <li>
                <a href="#highlightedProjects">Projects</a>
                </li>
                <li>
                <a href="#profileHeader">About Us</a>
                </li>
                <li>
                  <a href="#testimonials">Testimonials</a>
                </li>
            <li>
            <a href="#contact">Contact</a>
                </li>
                <li>
                    <a>(720)934-3184</a>
                </li>
                <li>
                <a>abe@elecba.com</a>
                </li>
          </ul>
        </div>
        </div>
        <div className="row">
          <div className="big-logo-container">
          <div className="overview" id="overview">
                    <h1 className="overview"> Electronics by Abe</h1>
                    <h3 className='tagline'>Hardware and Software Contract Services, Electronic Product Development</h3>
          </div>
          </div>
        </div>
        
      </div>
    </div>


    )
}

export default NavBar;